import * as yup from "yup";
import {INQUIRY_CONSTANT} from "../utils/constant";
import { title } from "process";

function getFileExtension(filename: any) {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
}
yup.addMethod(yup.array, "minWithoutUndefined", function (minValue, message) {
  return this.test("minWithoutUndefined", message, function (value) {
    if (!value) return false;
    const definedValues = value.filter((item) => item !== undefined);
    return definedValues.length >= minValue;
  });
});

const getFileExtensionSe = (filename: string): string | null => {
  if (!filename) return null;
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop()?.toLowerCase() ?? null : null;
};

// const validateImageDimensionsE = async (
//   file: File,
//   minWidth: number,
//   minHeight: number,
// ): Promise<boolean> => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.src = URL.createObjectURL(file);
//     img.onload = () => {
//       if (img.width >= minWidth && img.height >= minHeight) {
//         resolve(true);
//       } else {
//         reject(false);
//       }
//     };
//     img.onerror = () => reject(false);
//   });
// };

export const commerceCompassSchema = yup.object().shape({
  region: yup.object().required("Question 2"),
  country: yup.object().required("Question 3"),
  keyContact: yup.array().min(1, "Question 4").max(3).required("Question 4"),
  mainServiceId: yup.object().required(),
  compracticeLevels: yup
    .array()
    .min(1, "empty")
    .test("minWithoutUndefined", "Question 6", (value) => {
      if (!value) return false;
      const definedValues = value.filter(
        (item) =>
          (item?.compracticeLevel && !item?.secondaryServiceId) ||
          (!item?.compracticeLevel && item?.secondaryServiceId),
      );

      const checkEmptyValue = value.filter((e) => e?.compracticeLevel && e?.secondaryServiceId);

      return definedValues.length === 0 && checkEmptyValue.length > 0;
    }),
  highLevelPitch: yup.string().trim().required("Question 9"),
  videoLink: yup.string().trim().nullable().url("Question 10"),
  detailedDescription: yup.string().trim().required("Question 11"),
  urlLink: yup.string().trim().nullable().url("Question 12"),
  compracticeLevelsCustom: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        customName: yup.string(),
        compracticeLevel: yup.object(),
        isValid: yup.string().when(["customName", "compracticeLevel"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  locationServices: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        netRegionId: yup.object(),
        individualId: yup.array(),
        isValid: yup.string().when(["netRegionId", "individualId"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  sponsorProfile: yup.boolean(),
  startDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];
    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  endDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];
    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  sponsorMessage: yup.string().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema.required("sponsorProfile is required.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  serviceLogo: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtensionSe(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value) => {
      if (!value) return true;
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    }),
  filePdf: yup
    .mixed()
    .test("fileSize", "Question 14_", (value: any) => {
      if (value?.size) {
        return !(value.size > +(process.env.REACT_APP_PDF_SIZE_LIMIT || 4194304));
      }

      return true;
    })
    .test("type", "Question 14+", (value: any) => {
      if (value) {
        if (value?.type) {
          return value?.type.toString().includes("pdf");
        } else return false;
      }
      return true;
    }),
  comrelevantIndustry: yup.string().trim().required("Question 15"),
  acceptingClients: yup.bool().required("Question 16"),
  willingOfferAdvice: yup.bool().required("Question 17"),
  loanStaff: yup.bool().required("Question 18"),
  receiveStaff: yup.bool().required("Question 19"),
  globalOpportunities: yup.bool().required("Question 20"),
});

export const commerceCompassUpdateSchema = yup.object().shape({
  region: yup.object().required("Question 1"),
  country: yup.object().required("Question 2"),
  keyContact: yup.array().min(1, "Question 3").max(3).required("Question 3"),
  compracticeLevels: yup
    .array()
    .min(1, "empty")
    .test("minWithoutUndefined", "Question 6", (value) => {
      if (!value) return false;
      const definedValues = value.filter(
        (item) =>
          (item?.compracticeLevel === undefined && item?.secondaryServiceId !== undefined) ||
          (item?.compracticeLevel !== undefined && item?.secondaryServiceId === undefined),
      );

      const checkEmptyValue = value.filter((e) => e?.compracticeLevel && e?.secondaryServiceId);

      return definedValues.length === 0 && checkEmptyValue.length > 0;
    }),
  locationServices: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        netRegionId: yup.object(),
        individualId: yup.array(),
        isValid: yup.string().when(["netRegionId", "individualId"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  mainServiceId: yup.object().required(),
  highLevelPitch: yup.string().trim().required("Question 8"),
  videoLink: yup.string().trim().nullable().url("Question 9"),
  detailedDescription: yup.string().trim().required("Question 10"),
  urlLink: yup.string().trim().nullable().url("Question 11"),
  serviceLogo: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value || (value.name && !value.type) || !value.name) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtensionSe(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value) => {
      if (!value || (value.name && !value.type) || !value.name) {
        return true;
      }
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    }),
  filePdf: yup
    .mixed()
    .test("fileSize", "Question 12_", (value: any) => {
      if (value) {
        return !(value.size > +(process.env.REACT_APP_PDF_SIZE_LIMIT || 4194304));
      }

      return true;
    })
    .test("type", "Question 12+", (value: any) => {
      if (value) {
        if (value.name) {
          return value.name.toString().includes("pdf");
        } else return true;
      }
      return true;
    }),
  sponsorProfile: yup.boolean(),

  startDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];
    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),

  endDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  sponsorMessage: yup.string().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema.required("sponsorProfile is required.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  compracticeLevelsCustom: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        customName: yup.string(),
        compracticeLevel: yup.object(),
        isValid: yup.string().when(["customName", "compracticeLevel"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  comrelevantIndustry: yup.string().trim().required("Question 13"),
  willingOfferAdvice: yup.bool().required(),
  acceptingClients: yup.bool().required(),
});
export const descriptionSchema = yup.object().shape({
  tagLine: yup
    .mixed()
    .test("taglinechar", "Can not input des with length over 2000.", (value: any) => {
      if (value.length) {
        return !(value.length > 2000);
      }
      return true;
    }),
  description: yup
    .mixed()
    .test("taglinechar", "Can not input des with length over 2000.", (value: any) => {
      if (value.length) {
        return !(value.length > 2000);
      }
      return true;
    }),
});

export const brochureSchema = yup.object().shape({
  pdf: yup
    .mixed()
    .test("type", "Please select PDF file.", (value: any) => {
      if (value) {
        if (value.type) {
          return value && value?.type.toString().includes("pdf");
        } else return false;
      }
      return true;
    })
    .test("fileSize", "Please select file size less than 10MB.", (value: any) => {
      if (value?.size) {
        return !(value.size > 10485760);
      }
      return true;
    }),
});

export const videoSchema = yup.object().shape({
  videoUrl: yup
    .mixed()
    .nullable()
    .test("is-valid-url", "Please enter a valid URL.", (value: any) => {
      if (typeof value !== "string") return true;

      const trimmedValue = value.trim();

      if (trimmedValue === "") return true;

      const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
      return urlRegex.test(trimmedValue);
    }),
  offerorURL: yup
    .mixed()
    .nullable()
    .test("is-valid-url", "Please enter a valid URL.", (value: any) => {
      if (typeof value !== "string") return true;

      const trimmedValue = value.trim();

      if (trimmedValue === "") return true;

      const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
      return urlRegex.test(trimmedValue);
    }),
});

export const logoAndBackgroundSchema = yup.object().shape({
  logo: yup
    .mixed()
    .test("fileType", "Please select an image file.", (value: any) => {
      if (value?.type) {
        return (
          value &&
          value?.type.toString().includes("image") &&
          process.env.REACT_APP_IMG_EXT?.split(",")
            .map((e) => e.replace(".", ""))
            .includes(getFileExtension(value.name)?.toLowerCase())
        );
      }
      return false;
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value: any) => {
      if (value?.size) {
        return !(value.size > +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288));
      }
      return true;
    })
    .test(
      "image-size",
      "Please select a file size with a minimum of 150px by 150px.",
      async (value: any) => {
        try {
          if (value) {
            await validateImageDimensions(value, 150, 150);
            return true;
          }
          return true;
        } catch (error) {
          return false;
        }
      },
    ),
  bg: yup
    .mixed()
    .notRequired()
    .test("fileType", "Please select an image file.", (value: any) => {
      if (value?.type) {
        return (
          value &&
          value?.type.toString().includes("image") &&
          process.env.REACT_APP_IMG_EXT?.split(",")
            .map((e) => e.replace(".", ""))
            .includes(getFileExtension(value.name)?.toLowerCase())
        );
      }
      return true;
    })
    .test("fileSize", "Please select file size less than 2MB.", (value: any) => {
      if (value?.size) {
        return !(value.size > +(process.env.REACT_APP_IMG_BG_SIZE_LIMIT || 2097152));
      }
      return true;
    })
    .test(
      "image-size",
      "Please select a file size with a minimum of 600px by 200px.",
      async (value: any) => {
        try {
          if (value) {
            await validateImageDimensions(value, 600, 200);
            return true;
          }
          return true;
        } catch (error) {
          return false;
        }
      },
    ),
});

async function validateImageDimensions(
  file: File,
  width: number,
  height: number,
): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const img = new Image();
      img.src = event.target?.result as string;

      img.onload = () => {
        if (img.width >= width && img.height >= height) {
          resolve(true);
        } else {
          reject(false);
        }
      };
    };

    reader.readAsDataURL(file);
  });
}

export const formSendMessageSchema = yup.object().shape({
  subject: yup.string().trim().required("Required"),
  message: yup.string().trim().required("Required"),
});

// Product schema

export const CommerceProductSchema = yup.object().shape({
  region: yup.object().required("Question 2"),
  country: yup.object().required("Question 3"),
  keyContact: yup.array().min(1, "Question 4").max(3).required("Question 4"),
  mainServiceId: yup.object().required(),
  compracticeLevels: yup
    .array()
    .min(1, "empty")
    .test("minWithoutUndefined", "Question 6", (value) => {
      if (!value || value.length === 0) return false;

      const hasValidValue = value.some((item) => item?.secondaryServiceId);
      if (!hasValidValue) return false;

      return value.every((item, index, array) => {
        if (item?.secondaryServiceId) {
          return true;
        }

        const prevValid = array.slice(0, index).some((i) => i?.secondaryServiceId);
        const nextValid = array.slice(index + 1).some((i) => i?.secondaryServiceId);

        return prevValid || nextValid;
      });
    }),
  videoLink: yup.string().trim().nullable().url("Question 10"),
  detailedDescription: yup.string().trim().required("Question 11"),
  title: yup.string().trim().required("required"),
  tagLine: yup.string().trim().required("tagLine"),
  urlLink: yup.string().trim().nullable().url("Question 12"),
  compracticeLevelsCustom: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        customName: yup.string(),
        compracticeLevel: yup.object(),
        isValid: yup.string().when(["customName", "compracticeLevel"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  locationServices: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        netRegionId: yup.object(),
        individualId: yup.array(),
        isValid: yup.string().when(["netRegionId", "individualId"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  sponsorProfile: yup.boolean(),

  startDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];
    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),

  endDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  sponsorMessage: yup.string().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema.required("sponsorProfile is required.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  filePdf: yup
    .mixed()
    .test("fileSize", "Question 14_", (value: any) => {
      if (value?.size) {
        return !(value.size > +(process.env.REACT_APP_PDF_SIZE_LIMIT || 4194304));
      }

      return true;
    })
    .test("type", "Question 14+", (value: any) => {
      if (value) {
        if (value?.type) {
          return value?.type.toString().includes("pdf");
        } else return false;
      }

      return true;
    }),
  serviceLogo: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtensionSe(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value) => {
      if (!value) return true;
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    }),
});


// Secondment schema
export const CommerceSecondmentSchema = yup.object().shape({
  region: yup.object().required("Question 2"),
  country: yup.object().required("Question 3"),
  keyContact: yup.array().min(1, "Question 4").max(3).required("Question 4"),
  mainServiceId: yup.object().required(),
  title: yup.string().trim().required("Question 1"),
  interestType: yup
    .array()
    .min(1, "Question 5")
    .max(2)
    .test("Question 6", "At least one interest type must be selected", (value) => {
      if (!value || value.length === 0) return false;
      const allUnchecked = value.every((item) => item.isChecked === false);
      if (allUnchecked) return false;

      return true;
    }),
  videoLink: yup.string().trim().nullable().url("Question 10"),
  detailedDescription: yup.string().trim().required("Question 11"),
});

export const UpdateCommerceSecondmentSchema = yup.object().shape({
  region: yup.object().required("Question 2"),
  country: yup.object().required("Question 3"),
  keyContact: yup.array().min(1, "Question 4").max(3).required("Question 4"),
  mainServiceId: yup.object().required(),
  title: yup.string().trim().required("Question 1"),
  interestType: yup
    .array()
    .min(1, "Question 5")
    .max(2)
    .test("Question 6", "At least one interest type must be selected", (value) => {
      if (!value || value.length === 0) return false;
      const allUnchecked = value.every((item) => item.isChecked === false);
      if (allUnchecked) return false;

      return true;
    }),
  videoLink: yup.string().trim().nullable().url("Question 10"),
  detailedDescription: yup.string().trim().required("Question 11"),
});


// Update product schema

export const CommerceUpdateProductSchema = yup.object().shape({
  region: yup.object().required("Question 2"),
  country: yup.object().required("Question 3"),
  keyContact: yup.array().min(1, "Question 4").max(3).required("Question 4"),
  mainServiceId: yup.object().required(),
  compracticeLevels: yup
    .array()
    .min(1, "empty")
    .test("minWithoutUndefined", "Question 6", (value) => {
      if (!value || value.length === 0) return false;

      const hasValidValue = value.some((item) => item?.secondaryServiceId);
      if (!hasValidValue) return false;

      return value.every((item, index, array) => {
        if (item?.secondaryServiceId) {
          return true;
        }

        const prevValid = array.slice(0, index).some((i) => i?.secondaryServiceId);
        const nextValid = array.slice(index + 1).some((i) => i?.secondaryServiceId);

        return prevValid || nextValid;
      });
    }),
  videoLink: yup.string().trim().nullable().url("Question 10"),
  detailedDescription: yup.string().trim().required("Question 11"),
  title: yup.string().trim().required("required"),
  tagLine: yup.string().trim().required("tagLine"),
  urlLink: yup.string().trim().nullable().url("Question 12"),
  compracticeLevelsCustom: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        customName: yup.string(),
        compracticeLevel: yup.object(),
        isValid: yup.string().when(["customName", "compracticeLevel"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  locationServices: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        netRegionId: yup.object(),
        individualId: yup.array(),
        isValid: yup.string().when(["netRegionId", "individualId"], (e, f) => {
          if ((e[0] && e[1]) || (!e[0] && !e[1])) {
            return f;
          } else {
            return f.required();
          }
        }),
      }),
  ),
  sponsorProfile: yup.boolean(),

  startDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];
    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),

  endDate: yup.date().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema
        .required("Start Date is required.")
        .typeError("Start Date must be a valid date.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  sponsorMessage: yup.string().when("sponsorProfile", (sponsorProfile: any, schema: any) => {
    const isSponsorProfileTrue = Array.isArray(sponsorProfile) && sponsorProfile[0];

    if (isSponsorProfileTrue) {
      return schema.required("sponsorProfile is required.");
    } else {
      return schema.nullable().notRequired();
    }
  }),
  filePdf: yup
    .mixed()
    .test("fileSize", "Question 12_", (value: any) => {
      if (value) {
        return !(value.size > +(process.env.REACT_APP_PDF_SIZE_LIMIT || 4194304));
      }

      return true;
    })
    .test("type", "Question 12+", (value: any) => {
      if (value) {
        if (value.name) {
          return value.name.toString().includes("pdf");
        } else return true;
      }
      return true;
    }),
  serviceLogo: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value || (value.name && !value.type) || !value.name) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtensionSe(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value) => {
      if (!value || (value.name && !value.type) || !value.name) {
        return true;
      }
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    }),
});

export const addInquirySchema = yup.object().shape({
  inquiryDate: yup.date().nullable().required(),
  inquirySenderFirm: yup.object().nullable().required(),
  inquirySender: yup.object().nullable().required(),
  inquiryReceiverFirm: yup.object().nullable().required(),
  inquiryReceiver: yup.array().min(1).required(),
  subject: yup.string().trim().required(),
  body: yup.string().trim().required(),
  dealValue: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
  onetimeFee: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
  mainService: yup.object().when("offeringType", ([offeringType], schema) => {


    if (!offeringType) {
      return schema.nullable().notRequired();
    } else {
      return schema.nullable().required();
    }
  }),
  businessGeneratingTypeId: yup.number().notOneOf([0]).required(),
  // senderRegion: yup.object().nullable().required(),
  senderCountry: yup.object().nullable().required(),
  // receiverRegion: yup.object().nullable().required(),
  receiverCountry: yup.object().nullable().required(),
  recurringFee: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
});

export const editInquirySchema = yup.object().shape({
  businessGeneratingTypeId: yup.number().when("inquiryType", (value: any, schema: any) => {
    if (value[0] === INQUIRY_CONSTANT.INQUIRY_TYPE_NAME.INSIDE) {
      return schema.nullable().notRequired();
    } else {
      return schema.nullable().notOneOf([0]).required();
    }
  }),
  dealValue: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
  onetimeFee: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
  recurringFee: yup
    .number()
    .typeError("")
    .test("is-greater-than-zero", "The amount must be greater than 0", (value: any) => {
      if (value === null || value === "") return true;
      return value > 0;
    })
    .notRequired(),
});
